import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import user from './modules/user'
import sysParams from './modules/sysParams'
import getters from './getters'
const debug = process.env.NODE_ENV !== 'production'
Vue.use(Vuex)
export default new Vuex.Store({
	modules: {
		user,
		sysParams
	},
	strict: debug,
	plugins: debug ? [createLogger()] : [],
	state: {},
	mutations: {},
	actions: {},
	getters
})
